const INVOICE_TYPE = {
  RV: 'RV',
  TD: 'TD',
  FI: 'FI',
  PS: 'PS',
  TP: 'TP'
}

export default INVOICE_TYPE
